'use strict';

var _jsx = require('@babel/runtime/helpers/jsx');
var React = require('react');
require('prop-types');
var classnames = require('classnames');
function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
  if (typeof f == "function") {
    var a = function a() {
      if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {
    value: true
  });
  Object.keys(n).forEach(function (k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function () {
        return n[k];
      }
    });
  });
  return a;
}
const RECOMMENDATIONS_HEART_EMPTY = 'recommendations-heart-empty';
const RECOMMENDATIONS_HEART_FULL = 'recommendations-heart-full';
const RECOMMENDATIONS_FULL_ICON = 'recommendations-full_icon';
const RECOMMENDATIONS_CHEVRON = 'recommendations-chevron';
const RECOMMENDATIONS_START_EMPTY = 'recommendations-star-empty';
const RECOMMENDATIONS_START_HALF = 'recommendations-star-half';
const RECOMMENDATIONS_START_FULL = 'recommendations-star-full';
const RECOMMENDATIONS_MELI_LOGO = 'recommendations-meli_logo';
const RECOMMENDATIONS_MELI_COINS = 'recommendations-meli_coins';
const RECOMMENDATIONS_CPG_ICON = 'recommendations-cpg_icon';
const RECOMMENDATIONS_CBT_ICON = 'recommendations-cbt_icon';
const RECOMMENDATIONS_BLACK_FRIDAY_ICON = 'recommendations-black-friday_icon';
const RECOMMENDATIONS_MELICHOICE_LOGO = 'recommendations-melichoice_logo';
const RECOMMENDATIONS_BUFLO_ICON_INFO = 'recommendations-buflo_icon_info';
const RECOMMENDATIONS_MSHOPS_LOGO = 'recommendations-mshops_logo';
const RECOMMENDATIONS_CLOCK_ICON = 'recommendations-clock_icon';
const RECOMMENDATIONS_STORE_ICON = 'recommendations-store_icon';
const RECOMMENDATIONS_FIRE_ICON = 'recommendations-fire_icon';
const RECOMMENDATIONS_BADGE_ICON = 'recommendations-badge_icon';
const RECOMMENDATIONS_INFO_ICON = 'recommendations-info_icon';
const RECOMMENDATIONS_APPAREL_ICON = 'recommendations-clothing_icon';
const RECOMMENDATIONS_BEAUTY_ICON = 'recommendations-beauty_icon';
const RECOMMENDATIONS_TOOLS_ICON = 'recommendations-tools_icon';
const RECOMMENDATIONS_SUPERMARKET_ICON = 'recommendations-super_icon';
const RECOMMENDATIONS_DECO_ICON = 'recommendations-furniture_icon';
var icons = /*#__PURE__*/Object.freeze({
  __proto__: null,
  RECOMMENDATIONS_APPAREL_ICON: RECOMMENDATIONS_APPAREL_ICON,
  RECOMMENDATIONS_BADGE_ICON: RECOMMENDATIONS_BADGE_ICON,
  RECOMMENDATIONS_BEAUTY_ICON: RECOMMENDATIONS_BEAUTY_ICON,
  RECOMMENDATIONS_BLACK_FRIDAY_ICON: RECOMMENDATIONS_BLACK_FRIDAY_ICON,
  RECOMMENDATIONS_BUFLO_ICON_INFO: RECOMMENDATIONS_BUFLO_ICON_INFO,
  RECOMMENDATIONS_CBT_ICON: RECOMMENDATIONS_CBT_ICON,
  RECOMMENDATIONS_CHEVRON: RECOMMENDATIONS_CHEVRON,
  RECOMMENDATIONS_CLOCK_ICON: RECOMMENDATIONS_CLOCK_ICON,
  RECOMMENDATIONS_CPG_ICON: RECOMMENDATIONS_CPG_ICON,
  RECOMMENDATIONS_DECO_ICON: RECOMMENDATIONS_DECO_ICON,
  RECOMMENDATIONS_FIRE_ICON: RECOMMENDATIONS_FIRE_ICON,
  RECOMMENDATIONS_FULL_ICON: RECOMMENDATIONS_FULL_ICON,
  RECOMMENDATIONS_HEART_EMPTY: RECOMMENDATIONS_HEART_EMPTY,
  RECOMMENDATIONS_HEART_FULL: RECOMMENDATIONS_HEART_FULL,
  RECOMMENDATIONS_INFO_ICON: RECOMMENDATIONS_INFO_ICON,
  RECOMMENDATIONS_MELICHOICE_LOGO: RECOMMENDATIONS_MELICHOICE_LOGO,
  RECOMMENDATIONS_MELI_COINS: RECOMMENDATIONS_MELI_COINS,
  RECOMMENDATIONS_MELI_LOGO: RECOMMENDATIONS_MELI_LOGO,
  RECOMMENDATIONS_MSHOPS_LOGO: RECOMMENDATIONS_MSHOPS_LOGO,
  RECOMMENDATIONS_START_EMPTY: RECOMMENDATIONS_START_EMPTY,
  RECOMMENDATIONS_START_FULL: RECOMMENDATIONS_START_FULL,
  RECOMMENDATIONS_START_HALF: RECOMMENDATIONS_START_HALF,
  RECOMMENDATIONS_STORE_ICON: RECOMMENDATIONS_STORE_ICON,
  RECOMMENDATIONS_SUPERMARKET_ICON: RECOMMENDATIONS_SUPERMARKET_ICON,
  RECOMMENDATIONS_TOOLS_ICON: RECOMMENDATIONS_TOOLS_ICON
});
var require$$0 = /*@__PURE__*/getAugmentedNamespace(icons);
var constants = require$$0;
var _g, _rect, _defs;

// Recommendations-fe Packages
const namespace = 'ui-recommendations-icon';

/* eslint-disable max-len */
const StoreIcon = _ref => {
  let {
    className = null
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    className: classnames(namespace, className),
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    fill: "none",
    viewBox: "0 0 40 40"
  }, void 0, _g || (_g = /*#__PURE__*/_jsx("g", {
    clipPath: "url(#clip0_488_37014)"
  }, void 0, /*#__PURE__*/_jsx("rect", {
    width: "40",
    height: "40",
    fill: "#fff",
    rx: "20"
  }), /*#__PURE__*/_jsx("path", {
    stroke: "#3483FA",
    strokeWidth: "1.35",
    d: "M9.756 17.905v12.531h20.646V17.905"
  }), /*#__PURE__*/_jsx("path", {
    stroke: "#3483FA",
    strokeWidth: "1.35",
    d: "M12.78 24.191a2.84 2.84 0 012.84-2.84v0a2.84 2.84 0 012.84 2.84v6.25h-5.68v-6.25z"
  }), /*#__PURE__*/_jsx("path", {
    stroke: "#3483FA",
    strokeWidth: "1.35",
    d: "M21.432 22.158H27.432V26.948H21.432z"
  }), /*#__PURE__*/_jsx("path", {
    stroke: "#3483FA",
    strokeWidth: "1.35",
    d: "M23.906 15.908c0 1.178-1.78 2.133-3.975 2.133-2.196 0-3.976-.955-3.976-2.133v-2.68c0-.027.022-.048.048-.048h7.903v2.728z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    stroke: "#3483FA",
    strokeLinejoin: "round",
    strokeWidth: "1.35",
    d: "M31.852 15.908c0 1.178-1.78 2.133-3.976 2.133-2.196 0-3.976-.955-3.976-2.133v-2.68c0-.027.022-.048.048-.048h7.904v2.728z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    stroke: "#3483FA",
    strokeWidth: "1.35",
    d: "M15.951 15.908c0 1.178-1.78 2.133-3.975 2.133C9.78 18.041 8 17.086 8 15.908v-2.68c0-.027.021-.048.048-.048h7.903v2.728z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    fillOpacity: 1,
    fill: "#3483FA",
    d: "M9.836 9.967l-.588-.33h-.001l.589.33zm.32-.557l.553.387-.553-.387zm19.49.045l-.58.345.005.01.007.01.568-.365zm2.206 3.717v.675a.675.675 0 00.604-.977l-.604.302zm-23.85.006l-.55-.391a.675.675 0 00.55 1.066v-.675zm.015-.021l.547.396-.547-.396zm1.036-1.794l.588.33-.588-.33zm1.37-1.064a57.31 57.31 0 01.277-.486l.01-.016-1.106-.775c-.036.05-.092.149-.138.23-.057.098-.132.23-.218.384l1.176.663zm.286-.502c.067-.096.146-.122.197-.122v-1.35c-.533 0-1.007.276-1.302.697l1.105.775zm.197-.122h18.003v-1.35H10.906v1.35zm18.003 0c.018 0 .089.011.156.125l1.161-.69c-.271-.457-.75-.785-1.317-.785v1.35zm.169.145a61.657 61.657 0 011.672 2.744 30.054 30.054 0 01.472.86l.021.04.005.009v.002l.604-.303.603-.302v-.002l-.002-.004-.007-.013-.025-.049a31.048 31.048 0 00-.497-.907 63.004 63.004 0 00-1.71-2.804l-1.136.729zm2.774 2.677l-23.85.007v1.35l23.85-.007v-1.35zm-23.85.681l.55.392v-.001a.204.204 0 01.012-.016l-1.093-.792-.013.018-.004.005-.001.002v.001l.549.391zm.562.375c.08-.11.244-.391.42-.7.19-.328.423-.743.658-1.16l-1.178-.661c-.234.417-.465.826-.65 1.15a30.594 30.594 0 01-.314.533c-.022.036-.03.048-.03.046l1.094.792zm1.078-1.86l.782-1.395-1.177-.66-.783 1.394 1.178.66z"
  }))), _rect || (_rect = /*#__PURE__*/_jsx("rect", {
    width: "39",
    height: "39",
    x: "0.5",
    y: "0.5",
    stroke: "#000",
    strokeOpacity: "0.07",
    rx: "19.5"
  })), _defs || (_defs = /*#__PURE__*/_jsx("defs", {}, void 0, /*#__PURE__*/_jsx("clipPath", {
    id: "clip0_488_37014"
  }, void 0, /*#__PURE__*/_jsx("rect", {
    width: "40",
    height: "40",
    fill: "#fff",
    rx: "20"
  })))));
};
const StoreIconMemo = /*#__PURE__*/React.memo(StoreIcon);
StoreIconMemo.ICON_ID = constants.RECOMMENDATIONS_STORE_ICON;
var StoreIconMemo$1 = StoreIconMemo;
module.exports = StoreIconMemo$1;
